import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterConfig } from '../../models/filter-config';
import { filterDisplayService } from '../../engine/filter-display.service';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'app-filter-control',
  templateUrl: './filter-control.component.html',
  styleUrl: './filter-control.component.css'
})
export class FilterControlComponent {

  @Input() config!: FilterConfig;
  @Input() icono = undefined;

  @Output() opened = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Output() selected = new EventEmitter();
  
  public open = false;
  displayValue: string[] = [''];

  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',

      overlayX: 'end',
      overlayY: 'top'
    }
  ];


  constructor(
    private displayService: filterDisplayService,
  ){}

  ngOnChanges(){
    this.displayValue = this.displayService.getDisplayValue(this.config);
  }

  public toggle(){
    this.open = !this.open;
  }
  
  public close(): void {
    this.open = false;
  }
  
  selection(item){
    if(item.children) return;
    this.selected.emit(item);
  }
}
